import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Send1stAgreementIcon = () => /*#__PURE__*/_jsxs("svg", {
  width: "216",
  height: "180",
  viewBox: "0 0 216 180",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("g", {
    filter: "url(#filter0_dd_250_6195)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M190 56L110.103 34.8443C107.623 33.9143 104.116 34.6333 102.664 36.0879L21.8488 117.337C21.3916 117.796 20.684 118.037 20.5898 118.828C20.3965 120.452 22.6013 123.807 24.2088 124.238L108.622 146.856C110.605 147.387 113.391 146.639 114.843 145.185L195.037 64.4763C197.188 61.6915 191.984 56.5316 190 56Z",
      fill: "url(#paint0_linear_250_6195)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M189.479 55.8667L109.537 34.4462C106.336 33.5885 101.842 34.7928 99.4988 37.1359L21.707 114.928C19.3639 117.271 20.0591 119.866 23.2599 120.723L101.27 141.626C105.538 142.77 111.53 141.164 114.655 138.04L191.032 61.6622C193.375 59.3191 192.68 56.7243 189.479 55.8667Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter1_f_250_6195)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M115.276 139.583L191.475 62.0083C193.66 59.7838 193.129 57.3273 190.256 56.3697L186.985 55.2794L110.139 35.0347C106.942 34.1925 102.475 35.3936 100.137 37.724L22.1056 115.501C19.7753 117.824 20.43 120.402 23.5738 121.284L101.732 143.2C106.028 144.405 112.145 142.771 115.276 139.583Z",
      fill: "url(#paint1_linear_250_6195)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M189.479 55.8667L109.537 34.4462C106.336 33.5885 101.842 34.7928 99.4988 37.1359L21.707 114.928C19.3639 117.271 20.0591 119.866 23.2599 120.723L101.27 141.626C105.538 142.77 111.53 141.164 114.655 138.04L191.032 61.6622C193.375 59.3191 192.68 56.7243 189.479 55.8667Z",
    fill: "url(#paint2_linear_250_6195)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M62.9916 83.656C63.8108 82.9151 65.3372 82.5555 66.401 82.8529L116.829 96.9507C117.893 97.2481 118.091 98.0899 117.272 98.8308L116.564 99.4714C115.745 100.212 114.219 100.572 113.155 100.275L62.7264 86.1768C61.6626 85.8794 61.4643 85.0376 62.2835 84.2966L62.9916 83.656Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/_jsx("path", {
    d: "M56.5605 89.4728C57.3796 88.7318 58.9061 88.3722 59.9698 88.6696L95.4859 98.5986C96.5497 98.896 96.748 99.7377 95.9289 100.479L95.2207 101.119C94.4015 101.86 92.8751 102.22 91.8113 101.922L56.2952 91.9935C55.2315 91.6961 55.0332 90.8544 55.8523 90.1134L56.5605 89.4728Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/_jsx("path", {
    d: "M50.1303 95.2896C50.9495 94.5486 52.4759 94.1891 53.5397 94.4864L95.0207 106.083C96.0845 106.38 96.2828 107.222 95.4636 107.963L94.7554 108.604C93.9363 109.345 92.4098 109.704 91.3461 109.407L49.8651 97.8103C48.8013 97.5129 48.603 96.6712 49.4221 95.9302L50.1303 95.2896Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/_jsx("rect", {
    width: "44.594",
    height: "2.47745",
    rx: "1",
    transform: "matrix(0.963074 0.269238 -0.741612 0.670829 81.0103 67.3569)",
    fill: "#F3F0FF"
  }), /*#__PURE__*/_jsx("rect", {
    width: "49.5489",
    height: "2.47745",
    rx: "1",
    transform: "matrix(0.963074 0.269238 -0.741612 0.670829 76.4172 71.5117)",
    fill: "#F3F0FF"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter2_d_250_6195)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M157.891 47.1508C154.021 51.0209 146.556 53.1789 141.218 51.9711C138.943 51.4562 137.421 50.413 136.723 49.0857C134.649 45.3695 136.339 44.9972 138.56 42.7767C142.43 38.9067 149.894 36.7486 155.232 37.9565C157.44 38.456 158.645 37.9856 159.662 40.7243C160.353 42.5824 160.16 44.8813 157.891 47.1508Z",
      fill: "url(#paint3_linear_250_6195)"
    })
  }), /*#__PURE__*/_jsx("circle", {
    r: "9.90979",
    transform: "matrix(0.975342 0.220697 -0.707107 0.707107 147.606 43.7251)",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M140.454 58.7813C140.251 58.3545 139.559 58.1883 138.912 58.0278L63.9879 39.4224C63.0084 39.16 61.3849 39.7509 60.0865 40.784C59.6326 41.1452 59.1983 41.5174 58.6895 41.8511L53.4872 45.2636C51.9389 46.5023 53.017 49.0429 54.1633 49.35L130.473 69.7971C131.62 70.1044 133.647 69.2426 135.004 67.8713L139.917 62.9075C140.942 61.8718 140.916 59.7552 140.454 58.7813Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M139.678 58.0114L63.3684 37.5643C62.2222 37.2572 60.1938 38.1189 58.8368 39.4901L53.9245 44.4539C52.5675 45.8252 52.3975 47.1848 53.5438 47.492L129.853 67.939C131 68.2463 133.028 67.3845 134.385 66.0132L139.297 61.0494C140.654 59.6782 140.825 58.3187 139.678 58.0114Z",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.2546 41.5688L69.2546 41.5688C67.4017 40.9608 64.5652 41.5885 62.9189 42.9708C61.6346 44.0491 61.4205 45.31 62.3876 46.0999C62.693 46.3554 63.1053 46.5515 63.5992 46.6762L63.5992 46.6762C64.3958 46.8645 65.3618 46.8596 66.348 46.6621C66.5954 46.6128 66.792 46.4574 66.7874 46.3148C66.7837 46.1718 66.5799 46.0952 66.332 46.1437C66.3302 46.144 66.3284 46.1444 66.3266 46.1447C64.344 46.5342 62.7108 45.923 62.6786 44.7795C62.6464 43.636 64.2275 42.3932 66.2101 42.0037C67.104 41.8281 67.9712 41.8512 68.6419 42.0684C70.0225 42.5498 70.2147 43.7391 69.087 44.822L68.907 44.9986L68.907 44.9986C68.6554 45.2434 68.1749 45.3753 67.8339 45.2931C67.8265 45.2914 67.8192 45.2895 67.812 45.2875C67.4953 45.1791 67.4562 44.9053 67.7224 44.6606L68.8656 43.5389C69.0118 43.3955 68.968 43.2409 68.7678 43.1936C68.5859 43.1492 68.3315 43.2094 68.1752 43.3338C68.0698 43.0266 67.7524 42.7948 67.2883 42.6861C66.2639 42.4508 64.8365 42.8532 64.1002 43.5849C63.3639 44.3166 63.5975 45.1005 64.6219 45.3358C65.2094 45.4708 65.9623 45.3989 66.6514 45.1421C66.6007 45.6681 67.2818 45.9833 68.1726 45.846C68.2825 45.8291 68.3927 45.8056 68.5015 45.7759C68.9567 45.6563 69.3664 45.4366 69.6319 45.1699L69.8119 44.9933L69.8119 44.9933C71.2058 43.6461 70.9657 42.1703 69.2546 41.5688L69.2546 41.5688ZM65.1305 44.8118C64.512 44.6656 64.3767 44.1879 64.8283 43.7448C65.28 43.3017 66.1475 43.0609 66.766 43.2071C67.3846 43.3533 67.5198 43.831 67.0682 44.2741C66.6152 44.7161 65.7497 44.9563 65.1305 44.8118Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M133.728 59.5177L76.9139 44.2943C76.0605 44.0657 74.863 44.3913 74.2387 45.0221L71.9787 47.3058C71.3544 47.9367 71.5405 48.633 72.3939 48.8617L129.208 64.085C130.062 64.3138 131.259 63.9881 131.883 63.3572L134.143 61.0735C134.768 60.4427 134.582 59.7464 133.728 59.5177Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("filter", {
      id: "filter0_dd_250_6195",
      x: "0.577881",
      y: "4.42757",
      width: "214.971",
      height: "170.599",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_6195"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_250_6195",
        result: "effect2_dropShadow_250_6195"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_250_6195",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter1_f_250_6195",
      x: "19.7102",
      y: "33.7657",
      width: "174.108",
      height: "110.831",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "0.5",
        result: "effect1_foregroundBlur_250_6195"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter2_d_250_6195",
      x: "115.782",
      y: "21.6212",
      width: "64.2322",
      height: "54.6852",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "4"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.411765 0 0 0 0 0.258824 0 0 0 0 0.972549 0 0 0 0.12 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_6195"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_250_6195",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_250_6195",
      x1: "196.871",
      y1: "54.6731",
      x2: "11.813",
      y2: "9.54156",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#8B98DE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.200284",
        stopColor: "#C1CBFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.303741",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.310958",
        stopColor: "#DDE2FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.333069",
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.491969",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.857402",
        stopColor: "#94A0E3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#DAE0FF"
      })]
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "paint1_linear_250_6195",
      x1: "195.966",
      y1: "50.0149",
      x2: "-156.015",
      y2: "505.621",
      gradientUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      })
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "paint2_linear_250_6195",
      x1: "195.346",
      y1: "49.3954",
      x2: "-156.635",
      y2: "505.002",
      gradientUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      })
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint3_linear_250_6195",
      x1: "165.418",
      y1: "39.7427",
      x2: "154.942",
      y2: "26.8325",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.325361",
        stopColor: "#FCFCFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#E7EAF8"
      })]
    })]
  })]
});
export const ConnectBankAccountIcon = () => /*#__PURE__*/_jsxs("svg", {
  width: "205",
  height: "188",
  viewBox: "0 0 205 188",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("rect", {
    width: "7.67974",
    height: "33.5116",
    transform: "matrix(0.978148 0.207912 -0.707107 0.707107 111.225 36.7403)",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("rect", {
    width: "9.62992",
    height: "8.42599",
    rx: "1",
    transform: "matrix(0.978148 0.207912 -0.707107 0.707107 93.8037 52.6472)",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("rect", {
    width: "7.67974",
    height: "33.5116",
    transform: "matrix(0.978148 0.207912 -0.707107 0.707107 96.0269 33.8539)",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("rect", {
    width: "10.0312",
    height: "8.42618",
    rx: "1",
    transform: "matrix(0.978148 0.207912 -0.707107 0.707107 78.9604 49.4922)",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("rect", {
    width: "7.22244",
    height: "33.7047",
    transform: "matrix(0.978148 0.207912 -0.707107 0.707107 81.7881 30.4835)",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("rect", {
    width: "9.62992",
    height: "8.42599",
    rx: "1",
    transform: "matrix(0.978148 0.207912 -0.707107 0.707107 64.439 46.4055)",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("rect", {
    width: "7.62369",
    height: "52.9646",
    transform: "matrix(-0.707107 0.707107 -0.978148 -0.207912 108.198 58.8031)",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("path", {
    d: "M125.555 35.8532C126.758 36.9088 126.57 38.5281 125.07 40.0273L74.8332 29.349C76.3324 27.8499 78.8812 26.7323 81.4031 26.4684L111.301 23.3392L125.555 35.8532Z",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter0_dd_236_4354)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M179.354 73.792L104.514 53.9753C102.191 53.1041 98.9062 53.7777 97.5458 55.1402L21.8896 131.203C21.4323 131.662 20.715 131.913 20.6594 132.719C20.5526 134.267 22.5753 137.314 24.0564 137.71L103.126 158.897C104.985 159.395 107.594 158.694 108.954 157.332L184.072 81.7318C186.087 79.1232 181.212 74.2899 179.354 73.792Z",
      fill: "url(#paint0_linear_236_4354)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M178.499 73.5688L104.351 53.7007C101.15 52.843 96.6557 54.0473 94.3125 56.3904L21.9816 128.721C19.6384 131.065 20.3337 133.659 23.5345 134.517L95.7514 153.867C100.019 155.011 106.011 153.405 109.136 150.281L180.052 79.3643C182.396 77.0212 181.7 74.4264 178.499 73.5688Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter1_f_236_4354)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M109.721 151.717L180.491 79.6695C182.676 77.445 182.145 74.9884 179.272 74.0309L176.53 73.1169L104.913 54.25C101.716 53.4078 97.2494 54.6089 94.9114 56.9392L22.3527 129.262C20.0224 131.585 20.6771 134.163 23.8209 135.045L96.1772 155.333C100.474 156.538 106.59 154.905 109.721 151.717Z",
      fill: "url(#paint1_linear_236_4354)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M178.499 73.5688L104.351 53.7007C101.15 52.843 96.6557 54.0473 94.3125 56.3904L21.9816 128.721C19.6384 131.065 20.3337 133.659 23.5345 134.517L95.7514 153.867C100.019 155.011 106.011 153.405 109.136 150.281L180.052 79.3643C182.396 77.0212 181.7 74.4264 178.499 73.5688Z",
    fill: "url(#paint2_linear_236_4354)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M61.4147 97.5913C62.2339 96.8503 63.7603 96.4907 64.8241 96.7881L134.164 116.173C135.227 116.47 135.426 117.312 134.607 118.053L128.674 123.42C127.854 124.161 126.328 124.52 125.264 124.223L55.9245 104.838C54.8608 104.541 54.6625 103.699 55.4816 102.958L61.4147 97.5913Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/_jsx("path", {
    d: "M76.2389 81.1136C77.0581 80.3727 78.5845 80.0131 79.6483 80.3104L148.988 99.6951C150.052 99.9925 150.25 100.834 149.431 101.575L143.498 106.942C142.679 107.683 141.152 108.043 140.088 107.745L70.7488 88.3606C69.685 88.0632 69.4867 87.2214 70.3058 86.4804L76.2389 81.1136Z",
    fill: "#F3F0FF"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter2_d_236_4354)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M149.277 65.5029C145.652 69.128 138.66 71.1495 133.659 70.018C131.528 69.5358 130.103 68.5586 129.45 67.3153C127.507 63.8344 129.09 63.4856 131.17 61.4057C134.795 57.7806 141.787 55.7591 146.787 56.8905C148.855 57.3585 149.984 56.9178 150.937 59.4832C151.583 61.2237 151.403 63.3771 149.277 65.5029Z",
      fill: "url(#paint3_linear_236_4354)"
    })
  }), /*#__PURE__*/_jsx("circle", {
    r: "9.28255",
    transform: "matrix(0.975342 0.220697 -0.707107 0.707107 139.643 62.294)",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M91.3572 124.562C91.1653 124.132 90.4789 123.961 89.8327 123.8L19.7123 106.388C18.8057 106.145 17.3101 106.682 16.1013 107.629C15.6426 107.988 15.2096 108.361 14.7008 108.695L9.87631 111.859C8.42595 113.019 9.43584 115.399 10.5096 115.687L81.9892 134.84C83.0633 135.128 84.9628 134.32 86.2339 133.036L90.8353 128.386C91.7813 127.431 91.7716 125.492 91.3572 124.562Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M90.6117 123.8L19.1321 104.647C18.0584 104.36 16.1584 105.167 14.8873 106.451L10.2859 111.101C9.01477 112.385 8.85558 113.659 9.92931 113.947L81.4089 133.099C82.483 133.387 84.3825 132.58 85.6537 131.296L90.2551 126.646C91.5262 125.361 91.6858 124.088 90.6117 123.8Z",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("path", {
    d: "M33.078 116.117C32.5525 115.976 32.1646 115.76 31.9143 115.468C31.6691 115.177 31.5756 114.846 31.6338 114.475C31.7009 114.1 31.9231 113.725 32.3002 113.348C32.6773 112.971 33.1397 112.662 33.6873 112.421C34.2438 112.178 34.8219 112.025 35.4216 111.961C36.0264 111.898 36.5915 111.937 37.117 112.078C37.6064 112.209 37.9754 112.408 38.224 112.676C38.4815 112.941 38.6007 113.243 38.5816 113.582L37.437 113.727C37.448 113.5 37.3679 113.3 37.1967 113.125C37.0344 112.947 36.791 112.815 36.4665 112.728C36.1213 112.636 35.7467 112.612 35.3427 112.657C34.9425 112.698 34.5543 112.802 34.1783 112.969C33.8112 113.133 33.4994 113.344 33.2429 113.6C32.9865 113.857 32.8325 114.112 32.781 114.366C32.7385 114.617 32.7985 114.842 32.9612 115.038C33.1276 115.231 33.3834 115.374 33.7285 115.466C34.0531 115.553 34.4002 115.582 34.7699 115.552C35.1486 115.519 35.5134 115.435 35.8644 115.3L36.2962 115.867C35.7723 116.071 35.225 116.197 34.6545 116.245C34.0929 116.291 33.5674 116.248 33.078 116.117ZM38.0671 117.454C37.6704 117.347 37.3758 117.185 37.1832 116.966C36.9958 116.748 36.9244 116.499 36.969 116.22C37.0187 115.941 37.185 115.661 37.4679 115.378C37.7507 115.095 38.0973 114.863 38.5077 114.681C38.9232 114.501 39.3566 114.387 39.808 114.341C40.2646 114.296 40.6912 114.326 41.0878 114.433C41.4794 114.538 41.7688 114.699 41.9562 114.916C42.1488 115.135 42.2228 115.385 42.1782 115.665C42.1336 115.944 41.9699 116.226 41.687 116.508C41.4042 116.791 41.055 117.023 40.6395 117.203C40.224 117.384 39.788 117.496 39.3314 117.541C38.8801 117.588 38.4586 117.558 38.0671 117.454ZM38.3565 115.616C38.1906 115.782 38.0894 115.948 38.0529 116.116C38.0253 116.28 38.0646 116.427 38.1709 116.556C38.2823 116.686 38.4513 116.782 38.678 116.843C38.9047 116.903 39.1503 116.919 39.415 116.889C39.6797 116.86 39.9314 116.791 40.1702 116.683C40.4179 116.572 40.6247 116.434 40.7907 116.268C40.9566 116.102 41.0533 115.937 41.0809 115.772C41.1174 115.605 41.0826 115.457 40.9763 115.328C40.87 115.199 40.7036 115.104 40.4769 115.044C40.2502 114.983 40.002 114.967 39.7322 114.995C39.4675 115.024 39.2113 115.094 38.9636 115.205C38.7248 115.313 38.5225 115.45 38.3565 115.616ZM46.29 115.827C46.7588 115.952 47.0312 116.157 47.1071 116.44C47.1882 116.725 47.0571 117.039 46.7139 117.382L44.8981 119.198L44.0326 118.966L45.6391 117.359C45.8616 117.137 45.9487 116.935 45.9004 116.755C45.861 116.572 45.6919 116.441 45.3932 116.361C45.0789 116.277 44.7567 116.279 44.4266 116.367C44.1002 116.452 43.8258 116.606 43.6032 116.828L42.008 118.423L41.1425 118.192L44.0275 115.307L44.893 115.538L44.5197 115.912C45.1384 115.705 45.7285 115.676 46.29 115.827ZM51.1224 117.121C51.5912 117.247 51.8635 117.452 51.9394 117.735C52.0205 118.02 51.8894 118.334 51.5463 118.677L49.7304 120.493L48.8649 120.261L50.4715 118.654C50.694 118.432 50.7811 118.23 50.7328 118.05C50.6934 117.867 50.5243 117.736 50.2255 117.656C49.9113 117.572 49.5891 117.574 49.2589 117.662C48.9325 117.747 48.6581 117.9 48.4356 118.123L46.8404 119.718L45.9749 119.486L48.8599 116.601L49.7254 116.833L49.352 117.207C49.9707 116.999 50.5608 116.971 51.1224 117.121ZM56.1541 120.392C56.0674 120.479 55.9767 120.56 55.8821 120.635L52.6906 119.78C52.5553 120.006 52.5388 120.212 52.641 120.397C52.7433 120.583 52.9541 120.718 53.2735 120.804C53.5207 120.87 53.7877 120.894 54.0743 120.875C54.361 120.856 54.6201 120.806 54.8517 120.724L55.0713 121.249C54.6767 121.383 54.2695 121.46 53.8496 121.482C53.4349 121.504 53.0447 121.467 52.6789 121.369C52.2668 121.258 51.9593 121.092 51.7565 120.871C51.5587 120.65 51.4796 120.399 51.519 120.118C51.5674 119.835 51.7349 119.55 52.0215 119.263C52.3006 118.984 52.6453 118.754 53.0556 118.572C53.4711 118.392 53.9001 118.279 54.3426 118.235C54.794 118.189 55.2129 118.218 55.5992 118.321C55.9908 118.426 56.2776 118.587 56.4599 118.803C56.6422 119.019 56.7084 119.266 56.6587 119.545C56.6089 119.823 56.4408 120.105 56.1541 120.392ZM55.4984 119.872C55.6351 119.65 55.6581 119.451 55.5676 119.274C55.486 119.094 55.3035 118.966 55.0202 118.89C54.742 118.816 54.4376 118.813 54.1071 118.882C53.7804 118.948 53.4791 119.073 53.2033 119.257L55.4984 119.872ZM57.3889 122.631C56.9922 122.524 56.6976 122.362 56.5051 122.143C56.3177 121.925 56.2462 121.677 56.2908 121.397C56.3406 121.119 56.5069 120.838 56.7897 120.555C57.0726 120.272 57.4191 120.04 57.8295 119.858C58.245 119.678 58.6785 119.565 59.1298 119.518C59.5864 119.473 60.013 119.504 60.4097 119.61C60.796 119.714 61.0848 119.872 61.276 120.086C61.4672 120.3 61.5417 120.542 61.4995 120.813L60.4162 120.946C60.4437 120.781 60.4044 120.634 60.2981 120.505C60.1919 120.377 60.0254 120.282 59.7987 120.221C59.5721 120.16 59.3238 120.144 59.054 120.172C58.7894 120.202 58.5332 120.272 58.2855 120.382C58.0467 120.49 57.8443 120.627 57.6784 120.793C57.5124 120.959 57.4112 121.126 57.3747 121.293C57.3471 121.458 57.3865 121.604 57.4927 121.733C57.6041 121.864 57.7732 121.959 57.9999 122.02C58.2265 122.081 58.4722 122.096 58.7368 122.067C59.0015 122.037 59.2558 121.969 59.4997 121.862L59.9155 122.397C59.5127 122.571 59.0875 122.679 58.6399 122.722C58.1923 122.765 57.7753 122.734 57.3889 122.631ZM62.2536 122.65C62.1216 122.782 62.0706 122.895 62.1006 122.99C62.1306 123.084 62.2383 123.156 62.4238 123.205C62.5989 123.252 62.8132 123.267 63.0665 123.248L62.4726 123.842C62.177 123.864 61.8979 123.839 61.6351 123.769C61.2178 123.657 60.9828 123.493 60.93 123.278C60.8809 123.06 60.9997 122.807 61.2863 122.52L62.7514 121.055L62.0869 120.877L62.6639 120.3L63.3284 120.478L64.0751 119.731L64.9406 119.963L64.1939 120.71L65.3066 121.008L64.7296 121.585L63.6169 121.287L62.2536 122.65Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M152.527 51.2061L153.052 51.7416L152.527 51.2061ZM150.176 42.7708L150.349 42.0409L150.176 42.7708ZM130.948 38.9949C131.351 39.0902 131.755 38.8407 131.851 38.4376C131.946 38.0345 131.697 37.6305 131.293 37.5352L130.948 38.9949ZM135.777 38.5953C135.374 38.5 134.97 38.7495 134.875 39.1526C134.779 39.5557 135.029 39.9598 135.432 40.0551L135.777 38.5953ZM137.674 40.5852C138.077 40.6805 138.481 40.431 138.576 40.0279C138.672 39.6248 138.422 39.2207 138.019 39.1254L137.674 40.5852ZM142.503 40.1856C142.099 40.0903 141.695 40.3398 141.6 40.7429C141.505 41.146 141.754 41.55 142.157 41.6453L142.503 40.1856ZM144.399 42.1754C144.802 42.2707 145.206 42.0212 145.302 41.6181C145.397 41.215 145.147 40.811 144.744 40.7157L144.399 42.1754ZM149.228 41.7758C148.825 41.6805 148.421 41.93 148.326 42.3331C148.23 42.7362 148.48 43.1403 148.883 43.2356L149.228 41.7758ZM150.726 43.7379C151.107 43.9009 151.548 43.7244 151.711 43.3436C151.874 42.9628 151.697 42.522 151.317 42.3589L150.726 43.7379ZM154.207 45.1387C154.028 44.7651 153.58 44.6071 153.206 44.7858C152.833 44.9646 152.675 45.4124 152.854 45.7861L154.207 45.1387ZM153.259 47.2408C153.299 47.6531 153.666 47.9546 154.078 47.9144C154.491 47.8742 154.792 47.5073 154.752 47.0951L153.259 47.2408ZM153.716 50.9689C153.958 50.6325 153.881 50.1639 153.544 49.9223C153.208 49.6807 152.739 49.7576 152.497 50.094L153.716 50.9689ZM151.527 51.1364C151.231 51.4264 151.227 51.9013 151.517 52.197C151.807 52.4927 152.282 52.4973 152.577 52.2072L151.527 51.1364ZM150.678 54.0698C150.974 53.7797 150.979 53.3049 150.689 53.0092C150.399 52.7135 149.924 52.7089 149.628 52.9989L150.678 54.0698ZM129.827 38.7299L130.948 38.9949L131.293 37.5352L130.173 37.2701L129.827 38.7299ZM135.432 40.0551L137.674 40.5852L138.019 39.1254L135.777 38.5953L135.432 40.0551ZM142.157 41.6453L144.399 42.1754L144.744 40.7157L142.503 40.1856L142.157 41.6453ZM148.883 43.2356L150.004 43.5006L150.349 42.0409L149.228 41.7758L148.883 43.2356ZM150.004 43.5006C150.259 43.561 150.5 43.641 150.726 43.7379L151.317 42.3589C151.011 42.2279 150.688 42.121 150.349 42.0409L150.004 43.5006ZM152.854 45.7861C153.072 46.243 153.21 46.7367 153.259 47.2408L154.752 47.0951C154.686 46.4169 154.501 45.7534 154.207 45.1387L152.854 45.7861ZM152.497 50.094C152.354 50.294 152.189 50.487 152.002 50.6707L153.052 51.7416C153.301 51.4979 153.522 51.2393 153.716 50.9689L152.497 50.094ZM152.002 50.6707L151.527 51.1364L152.577 52.2072L153.052 51.7416L152.002 50.6707ZM149.628 52.9989L149.153 53.4646L150.204 54.5354L150.678 54.0698L149.628 52.9989Z",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("path", {
    d: "M53.891 70.6635L53.2669 70.2475L53.891 70.6635ZM62.2091 81.3089C61.833 81.1354 61.3874 81.2995 61.2139 81.6756C61.0403 82.0517 61.2044 82.4973 61.5805 82.6709L62.2091 81.3089ZM57.1598 80.6306C57.5359 80.8041 57.9815 80.64 58.1551 80.2639C58.3286 79.8878 58.1645 79.4422 57.7884 79.2686L57.1598 80.6306ZM56.0202 78.3937C55.6724 78.1687 55.2081 78.2682 54.983 78.6159C54.758 78.9637 54.8575 79.428 55.2052 79.653L56.0202 78.3937ZM52.7166 76.7379C52.8847 77.1165 53.3278 77.2871 53.7064 77.119C54.085 76.9508 54.2556 76.5077 54.0875 76.1291L52.7166 76.7379ZM53.6778 74.6783C53.6231 74.2677 53.2459 73.9792 52.8353 74.0339C52.4247 74.0887 52.1362 74.4659 52.191 74.8764L53.6778 74.6783ZM52.7874 71.0902C52.6087 71.4639 52.7668 71.9116 53.1405 72.0903C53.5142 72.269 53.962 72.111 54.1407 71.7373L52.7874 71.0902ZM55.1074 70.1909C55.3372 69.8463 55.2441 69.3806 54.8994 69.1509C54.5548 68.9211 54.0891 69.0142 53.8594 69.3589L55.1074 70.1909ZM56.229 65.8044C55.9993 66.149 56.0924 66.6147 56.437 66.8444C56.7817 67.0742 57.2473 66.9811 57.4771 66.6364L56.229 65.8044ZM58.6619 64.8592C58.8917 64.5145 58.7986 64.0489 58.4539 63.8191C58.1093 63.5893 57.6436 63.6825 57.4139 64.0271L58.6619 64.8592ZM59.7835 60.4726C59.5538 60.8173 59.6469 61.2829 59.9916 61.5127C60.3362 61.7424 60.8019 61.6493 61.0316 61.3047L59.7835 60.4726ZM63.3143 81.819L62.2091 81.3089L61.5805 82.6709L62.6857 83.181L63.3143 81.819ZM57.7884 79.2686L56.6832 78.7585L56.0546 80.1205L57.1598 80.6306L57.7884 79.2686ZM56.6832 78.7585C56.4495 78.6507 56.2284 78.5285 56.0202 78.3937L55.2052 79.653C55.473 79.8263 55.7564 79.9828 56.0546 80.1205L56.6832 78.7585ZM54.0875 76.1291C53.8826 75.6678 53.7445 75.1787 53.6778 74.6783L52.191 74.8764C52.2765 75.5185 52.4537 76.1459 52.7166 76.7379L54.0875 76.1291ZM54.1407 71.7373C54.2477 71.5135 54.3722 71.2937 54.515 71.0796L53.2669 70.2475C53.0847 70.5208 52.925 70.8024 52.7874 71.0902L54.1407 71.7373ZM54.515 71.0796L55.1074 70.1909L53.8594 69.3589L53.2669 70.2475L54.515 71.0796ZM57.4771 66.6364L58.6619 64.8592L57.4139 64.0271L56.229 65.8044L57.4771 66.6364ZM61.0316 61.3047L61.624 60.416L60.376 59.584L59.7835 60.4726L61.0316 61.3047Z",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("filter", {
      id: "filter0_dd_236_4354",
      x: "0.655273",
      y: "23.5849",
      width: "203.896",
      height: "163.473",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_236_4354"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_236_4354",
        result: "effect2_dropShadow_236_4354"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_236_4354",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter1_f_236_4354",
      x: "19.957",
      y: "52.981",
      width: "162.877",
      height: "103.749",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "0.5",
        result: "effect1_foregroundBlur_236_4354"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter2_d_236_4354",
      x: "108.568",
      y: "40.5764",
      width: "62.6982",
      height: "53.7557",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "4"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.411765 0 0 0 0 0.258824 0 0 0 0 0.972549 0 0 0 0.12 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_236_4354"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_236_4354",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_236_4354",
      x1: "185.79",
      y1: "72.549",
      x2: "12.4452",
      y2: "30.2741",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#8B98DE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.200284",
        stopColor: "#C1CBFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.303741",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.310958",
        stopColor: "#DDE2FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.333069",
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.491969",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.857402",
        stopColor: "#94A0E3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#DAE0FF"
      })]
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "paint1_linear_236_4354",
      x1: "184.943",
      y1: "68.1857",
      x2: "-144.76",
      y2: "494.955",
      gradientUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      })
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "paint2_linear_236_4354",
      x1: "184.362",
      y1: "67.6054",
      x2: "-145.341",
      y2: "494.375",
      gradientUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      })
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint3_linear_236_4354",
      x1: "156.328",
      y1: "58.5637",
      x2: "146.515",
      y2: "46.4706",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.325361",
        stopColor: "#FCFCFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#E7EAF8"
      })]
    })]
  })]
});
export const CompleteKYCIcon = () => /*#__PURE__*/_jsxs("svg", {
  width: "205",
  height: "184",
  viewBox: "0 0 205 184",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("g", {
    filter: "url(#filter0_dd_242_4608)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M179.05 69.792L104.21 49.9753C101.887 49.1041 98.602 49.7777 97.2416 51.1402L21.5854 127.203C21.1281 127.662 20.4108 127.913 20.3553 128.719C20.2484 130.267 22.2711 133.314 23.7522 133.71L102.822 154.897C104.681 155.395 107.29 154.694 108.65 153.332L183.768 77.7318C185.783 75.1232 180.908 70.2899 179.05 69.792Z",
      fill: "url(#paint0_linear_242_4608)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M178.196 69.5688L104.048 49.7007C100.847 48.843 96.3525 50.0473 94.0093 52.3904L21.6784 124.721C19.3352 127.065 20.0305 129.659 23.2313 130.517L95.4481 149.867C99.7159 151.011 105.708 149.405 108.832 146.281L179.749 75.3643C182.092 73.0212 181.397 70.4264 178.196 69.5688Z",
    fill: "white"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter1_f_242_4608)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M109.417 147.717L180.186 75.6695C182.371 73.445 181.841 70.9884 178.968 70.0309L176.226 69.1169L104.609 50.25C101.412 49.4078 96.9452 50.6089 94.6072 52.9392L22.0485 125.262C19.7182 127.585 20.3729 130.163 23.5167 131.045L95.873 151.333C100.169 152.538 106.286 150.905 109.417 147.717Z",
      fill: "url(#paint1_linear_242_4608)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M178.196 69.5688L104.048 49.7007C100.847 48.843 96.3525 50.0473 94.0093 52.3904L21.6784 124.721C19.3352 127.065 20.0305 129.659 23.2313 130.517L95.4481 149.867C99.7159 151.011 105.708 149.405 108.832 146.281L179.749 75.3643C182.092 73.0212 181.397 70.4264 178.196 69.5688Z",
    fill: "url(#paint2_linear_242_4608)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M81.3356 54.9173C82.881 53.7848 85.1787 53.2434 86.9975 53.5437C90.3073 54.0903 95.1724 54.8279 95.5002 54.5C95.7884 54.2117 96.2307 55.0992 96.5536 55.9024C96.8414 56.6185 96.5197 57.4761 95.7366 58.2518L90.4611 63.4777C88.8848 65.0393 85.8738 65.855 83.7415 65.2983L76.727 63.4669C75.7328 63.2073 75.049 62.6798 74.9292 61.966C74.8171 61.2988 74.7576 60.4844 75 60C75.2934 59.4134 78.7998 56.7756 81.3356 54.9173Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("rect", {
    width: "15.0324",
    height: "15.0324",
    rx: "4",
    transform: "matrix(0.969231 0.246153 -0.707107 0.707107 83.6299 51)",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("mask", {
    id: "path-7-inside-1_242_4608",
    fill: "white",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M83.1557 59.7983C83.0312 59.7664 82.9501 59.6981 82.932 59.6098L82.4401 57.3574C82.402 57.1818 82.619 56.9763 82.9247 56.8982C83.2304 56.8202 83.509 56.8992 83.5471 57.0748L83.9617 58.9866L90.768 56.9293C91.065 56.8276 91.371 56.877 91.4515 57.0397C91.5319 57.2024 91.3563 57.4169 91.0593 57.5186C91.038 57.5259 91.0165 57.5325 90.9947 57.5383L83.5972 59.7747C83.4452 59.8212 83.2868 59.8302 83.1602 59.7995L83.1557 59.7983Z"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1557 59.7983C83.0312 59.7664 82.9501 59.6981 82.932 59.6098L82.4401 57.3574C82.402 57.1818 82.619 56.9763 82.9247 56.8982C83.2304 56.8202 83.509 56.8992 83.5471 57.0748L83.9617 58.9866L90.768 56.9293C91.065 56.8276 91.371 56.877 91.4515 57.0397C91.5319 57.2024 91.3563 57.4169 91.0593 57.5186C91.038 57.5259 91.0165 57.5325 90.9947 57.5383L83.5972 59.7747C83.4452 59.8212 83.2868 59.8302 83.1602 59.7995L83.1557 59.7983Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M83.1557 59.7983L81.7352 61.211L81.7416 61.2126L83.1557 59.7983ZM82.932 59.6098L85.3148 59.0084L85.3128 58.9992L82.932 59.6098ZM82.4401 57.3574L80.0589 57.9669L80.0592 57.9681L82.4401 57.3574ZM82.9247 56.8982L82.6308 55.5297L82.6308 55.5297L82.9247 56.8982ZM83.5471 57.0748L81.166 57.6843L81.166 57.6844L83.5471 57.0748ZM83.9617 58.9866L81.5806 59.5962L81.9006 61.0713L84.437 60.3046L83.9617 58.9866ZM90.768 56.9293L91.2433 58.2473L91.3185 58.2245L91.3927 58.1991L90.768 56.9293ZM91.4515 57.0397L89.1354 57.8348L89.1354 57.8348L91.4515 57.0397ZM91.0593 57.5186L90.4346 56.2488L90.4346 56.2488L91.0593 57.5186ZM90.9947 57.5383L90.6481 56.1837L90.5834 56.2011L90.5193 56.2204L90.9947 57.5383ZM83.5972 59.7747L83.1217 58.4568L83.1067 58.4614L83.5972 59.7747ZM83.1602 59.7995L81.7461 61.2137L81.7581 61.2168L81.7701 61.2197L83.1602 59.7995ZM84.5761 58.3857C84.9869 58.4912 85.2546 58.7166 85.3148 59.0084L80.5491 60.2113C80.6456 60.6796 81.0754 61.0415 81.7352 61.211L84.5761 58.3857ZM85.3128 58.9992L84.8209 56.7467L80.0592 57.9681L80.5511 60.2205L85.3128 58.9992ZM84.8212 56.748C84.947 57.3285 84.2289 58.0088 83.2185 58.2667L82.6308 55.5297C81.009 55.9438 79.857 57.0352 80.0589 57.9669L84.8212 56.748ZM83.2185 58.2667C82.2102 58.5241 81.2916 58.2636 81.166 57.6843L85.9282 56.4653C85.7265 55.5349 84.2506 55.1162 82.6308 55.5297L83.2185 58.2667ZM81.166 57.6844L81.5806 59.5962L86.3428 58.3771L85.9282 56.4652L81.166 57.6844ZM84.437 60.3046L91.2433 58.2473L90.2927 55.6114L83.4865 57.6687L84.437 60.3046ZM91.3927 58.1991C90.4107 58.5355 89.4009 58.3721 89.1354 57.8348L93.7675 56.2446C93.3411 55.3819 91.7194 55.1196 90.1433 55.6595L91.3927 58.1991ZM89.1354 57.8348C88.8693 57.2965 89.4506 56.586 90.4346 56.2488L91.6839 58.7884C93.262 58.2478 94.1945 57.1084 93.7675 56.2446L89.1354 57.8348ZM90.4346 56.2488C90.5049 56.2247 90.5762 56.203 90.6481 56.1837L91.3413 58.893C91.4567 58.862 91.5711 58.8271 91.6839 58.7884L90.4346 56.2488ZM90.5193 56.2204L83.1218 58.4568L84.0726 61.0926L91.4702 58.8562L90.5193 56.2204ZM83.1067 58.4614C83.6094 58.3074 84.1325 58.2779 84.5502 58.3793L81.7701 61.2197C82.4412 61.3826 83.281 61.3351 84.0877 61.088L83.1067 58.4614ZM84.5742 58.3852L84.5697 58.3841L81.7416 61.2126L81.7461 61.2137L84.5742 58.3852Z",
    fill: "#FCFCFD",
    mask: "url(#path-7-inside-1_242_4608)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M64.859 70.9173C66.4044 69.7848 68.7021 69.2434 70.521 69.5437C73.8308 70.0903 78.6958 70.8279 79.0236 70.5C79.3118 70.2117 79.7541 71.0992 80.077 71.9024C80.3649 72.6185 80.0431 73.4761 79.26 74.2518L73.9846 79.4777C72.4082 81.0393 69.3973 81.855 67.2649 81.2983L60.2505 79.4669C59.2563 79.2073 58.5724 78.6798 58.4526 77.966C58.3406 77.2988 58.2811 76.4844 58.5234 76C58.8169 75.4134 62.3232 72.7756 64.859 70.9173Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("rect", {
    width: "15.0324",
    height: "15.0324",
    rx: "4",
    transform: "matrix(0.969231 0.246153 -0.707107 0.707107 67.1533 67)",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("mask", {
    id: "path-11-inside-2_242_4608",
    fill: "white",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M66.6791 75.7983C66.5546 75.7664 66.4736 75.6981 66.4554 75.6098L65.9635 73.3574C65.9254 73.1818 66.1424 72.9763 66.4481 72.8982C66.7538 72.8202 67.0325 72.8992 67.0705 73.0748L67.4852 74.9866L74.2914 72.9293C74.5885 72.8276 74.8945 72.877 74.9749 73.0397C75.0553 73.2024 74.8797 73.4169 74.5827 73.5186C74.5615 73.5259 74.5399 73.5325 74.5181 73.5383L67.1206 75.7747C66.9687 75.8212 66.8103 75.8302 66.6836 75.7995L66.6791 75.7983Z"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6791 75.7983C66.5546 75.7664 66.4736 75.6981 66.4554 75.6098L65.9635 73.3574C65.9254 73.1818 66.1424 72.9763 66.4481 72.8982C66.7538 72.8202 67.0325 72.8992 67.0705 73.0748L67.4852 74.9866L74.2914 72.9293C74.5885 72.8276 74.8945 72.877 74.9749 73.0397C75.0553 73.2024 74.8797 73.4169 74.5827 73.5186C74.5615 73.5259 74.5399 73.5325 74.5181 73.5383L67.1206 75.7747C66.9687 75.8212 66.8103 75.8302 66.6836 75.7995L66.6791 75.7983Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M66.6791 75.7983L65.2587 77.211L65.2651 77.2126L66.6791 75.7983ZM66.4554 75.6098L68.8383 75.0084L68.8363 74.9992L66.4554 75.6098ZM65.9635 73.3574L63.5824 73.9669L63.5826 73.9681L65.9635 73.3574ZM66.4481 72.8982L66.1543 71.5297L66.1543 71.5297L66.4481 72.8982ZM67.0705 73.0748L64.6894 73.6843L64.6894 73.6844L67.0705 73.0748ZM67.4852 74.9866L65.1041 75.5962L65.424 77.0713L67.9605 76.3046L67.4852 74.9866ZM74.2914 72.9293L74.7667 74.2473L74.842 74.2245L74.9161 74.1991L74.2914 72.9293ZM74.9749 73.0397L72.6588 73.8348L72.6588 73.8348L74.9749 73.0397ZM74.5827 73.5186L73.958 72.2488L73.958 72.2488L74.5827 73.5186ZM74.5181 73.5383L74.1715 72.1837L74.1068 72.2011L74.0427 72.2204L74.5181 73.5383ZM67.1206 75.7747L66.6452 74.4568L66.6302 74.4614L67.1206 75.7747ZM66.6836 75.7995L65.2696 77.2137L65.2815 77.2168L65.2936 77.2197L66.6836 75.7995ZM68.0995 74.3857C68.5103 74.4912 68.7781 74.7166 68.8382 75.0084L64.0726 76.2113C64.1691 76.6796 64.5989 77.0415 65.2587 77.211L68.0995 74.3857ZM68.8363 74.9992L68.3443 72.7467L63.5826 73.9681L64.0745 76.2205L68.8363 74.9992ZM68.3446 72.748C68.4704 73.3285 67.7524 74.0088 66.742 74.2667L66.1543 71.5297C64.5325 71.9438 63.3804 73.0352 63.5824 73.9669L68.3446 72.748ZM66.742 74.2667C65.7336 74.5241 64.815 74.2636 64.6894 73.6843L69.4517 72.4653C69.25 71.5349 67.774 71.1162 66.1543 71.5297L66.742 74.2667ZM64.6894 73.6844L65.1041 75.5962L69.8663 74.3771L69.4516 72.4652L64.6894 73.6844ZM67.9605 76.3046L74.7667 74.2473L73.8161 71.6114L67.0099 73.6687L67.9605 76.3046ZM74.9161 74.1991C73.9341 74.5355 72.9243 74.3721 72.6588 73.8348L77.291 72.2446C76.8646 71.3819 75.2428 71.1196 73.6667 71.6595L74.9161 74.1991ZM72.6588 73.8348C72.3927 73.2965 72.974 72.586 73.958 72.2488L75.2074 74.7884C76.7854 74.2478 77.7179 73.1084 77.291 72.2446L72.6588 73.8348ZM73.958 72.2488C74.0284 72.2247 74.0996 72.203 74.1715 72.1837L74.8648 74.893C74.9802 74.862 75.0946 74.8271 75.2074 74.7884L73.958 72.2488ZM74.0427 72.2204L66.6452 74.4568L67.5961 77.0926L74.9936 74.8562L74.0427 72.2204ZM66.6302 74.4614C67.1328 74.3074 67.6559 74.2779 68.0736 74.3793L65.2936 77.2197C65.9646 77.3826 66.8045 77.3351 67.6111 77.088L66.6302 74.4614ZM68.0977 74.3852L68.0932 74.3841L65.2651 77.2126L65.2696 77.2137L68.0977 74.3852Z",
    fill: "#FCFCFD",
    mask: "url(#path-11-inside-2_242_4608)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M47.859 87.9173C49.4044 86.7848 51.7021 86.2434 53.521 86.5437C56.8308 87.0903 61.6958 87.8279 62.0236 87.5C62.3118 87.2117 62.7541 88.0992 63.077 88.9024C63.3649 89.6185 63.0431 90.4761 62.26 91.2518L56.9846 96.4777C55.4082 98.0393 52.3973 98.855 50.2649 98.2983L43.2505 96.4669C42.2563 96.2073 41.5724 95.6798 41.4526 94.966C41.3406 94.2988 41.2811 93.4844 41.5234 93C41.8169 92.4134 45.3232 89.7756 47.859 87.9173Z",
    fill: "#4926CD"
  }), /*#__PURE__*/_jsx("rect", {
    width: "15.0324",
    height: "15.0324",
    rx: "4",
    transform: "matrix(0.969231 0.246153 -0.707107 0.707107 50.1533 84)",
    fill: "#6942F8"
  }), /*#__PURE__*/_jsx("mask", {
    id: "path-15-inside-3_242_4608",
    fill: "white",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M49.6791 92.7983C49.5546 92.7664 49.4736 92.6981 49.4554 92.6098L48.9635 90.3574C48.9254 90.1818 49.1424 89.9763 49.4481 89.8982C49.7538 89.8202 50.0325 89.8992 50.0705 90.0748L50.4852 91.9866L57.2914 89.9293C57.5885 89.8276 57.8945 89.877 57.9749 90.0397C58.0553 90.2024 57.8797 90.4169 57.5827 90.5186C57.5615 90.5259 57.5399 90.5325 57.5181 90.5383L50.1206 92.7747C49.9687 92.8212 49.8103 92.8302 49.6836 92.7995L49.6791 92.7983Z"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6791 92.7983C49.5546 92.7664 49.4736 92.6981 49.4554 92.6098L48.9635 90.3574C48.9254 90.1818 49.1424 89.9763 49.4481 89.8982C49.7538 89.8202 50.0325 89.8992 50.0705 90.0748L50.4852 91.9866L57.2914 89.9293C57.5885 89.8276 57.8945 89.877 57.9749 90.0397C58.0553 90.2024 57.8797 90.4169 57.5827 90.5186C57.5615 90.5259 57.5399 90.5325 57.5181 90.5383L50.1206 92.7747C49.9687 92.8212 49.8103 92.8302 49.6836 92.7995L49.6791 92.7983Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M49.6791 92.7983L48.2587 94.211L48.2651 94.2126L49.6791 92.7983ZM49.4554 92.6098L51.8383 92.0084L51.8363 91.9992L49.4554 92.6098ZM48.9635 90.3574L46.5824 90.9669L46.5826 90.9681L48.9635 90.3574ZM49.4481 89.8982L49.1543 88.5297L49.1543 88.5297L49.4481 89.8982ZM50.0705 90.0748L47.6894 90.6843L47.6894 90.6844L50.0705 90.0748ZM50.4852 91.9866L48.1041 92.5962L48.424 94.0713L50.9605 93.3046L50.4852 91.9866ZM57.2914 89.9293L57.7667 91.2473L57.842 91.2245L57.9161 91.1991L57.2914 89.9293ZM57.9749 90.0397L55.6588 90.8348L55.6588 90.8348L57.9749 90.0397ZM57.5827 90.5186L56.958 89.2488L56.958 89.2488L57.5827 90.5186ZM57.5181 90.5383L57.1715 89.1837L57.1068 89.2011L57.0427 89.2204L57.5181 90.5383ZM50.1206 92.7747L49.6452 91.4568L49.6302 91.4614L50.1206 92.7747ZM49.6836 92.7995L48.2696 94.2137L48.2815 94.2168L48.2936 94.2197L49.6836 92.7995ZM51.0995 91.3857C51.5103 91.4912 51.7781 91.7166 51.8382 92.0084L47.0726 93.2113C47.1691 93.6796 47.5989 94.0415 48.2587 94.211L51.0995 91.3857ZM51.8363 91.9992L51.3443 89.7467L46.5826 90.9681L47.0745 93.2205L51.8363 91.9992ZM51.3446 89.748C51.4704 90.3285 50.7524 91.0088 49.742 91.2667L49.1543 88.5297C47.5325 88.9438 46.3804 90.0352 46.5824 90.9669L51.3446 89.748ZM49.742 91.2667C48.7336 91.5241 47.815 91.2636 47.6894 90.6843L52.4517 89.4653C52.25 88.5349 50.774 88.1162 49.1543 88.5297L49.742 91.2667ZM47.6894 90.6844L48.1041 92.5962L52.8663 91.3771L52.4516 89.4652L47.6894 90.6844ZM50.9605 93.3046L57.7667 91.2473L56.8161 88.6114L50.0099 90.6687L50.9605 93.3046ZM57.9161 91.1991C56.9341 91.5355 55.9243 91.3721 55.6588 90.8348L60.291 89.2446C59.8646 88.3819 58.2428 88.1196 56.6667 88.6595L57.9161 91.1991ZM55.6588 90.8348C55.3927 90.2965 55.974 89.586 56.958 89.2488L58.2074 91.7884C59.7854 91.2478 60.7179 90.1084 60.291 89.2446L55.6588 90.8348ZM56.958 89.2488C57.0284 89.2247 57.0996 89.203 57.1715 89.1837L57.8648 91.893C57.9802 91.862 58.0946 91.8271 58.2074 91.7884L56.958 89.2488ZM57.0427 89.2204L49.6452 91.4568L50.5961 94.0926L57.9936 91.8562L57.0427 89.2204ZM49.6302 91.4614C50.1328 91.3074 50.6559 91.2779 51.0736 91.3793L48.2936 94.2197C48.9646 94.3826 49.8045 94.3351 50.6111 94.088L49.6302 91.4614ZM51.0977 91.3852L51.0932 91.3841L48.2651 94.2126L48.2696 94.2137L51.0977 91.3852Z",
    fill: "#FCFCFD",
    mask: "url(#path-15-inside-3_242_4608)"
  }), /*#__PURE__*/_jsx("path", {
    d: "M72.3607 127.789C59.7922 125.263 51.731 119.717 48.5904 112.597C49.1519 111.99 49.7527 111.384 50.3932 110.778C63.6945 98.2047 89.0246 90.9347 106.97 94.5403C124.915 98.1459 128.679 111.262 115.378 123.835C114.522 124.645 113.616 125.431 112.666 126.195C98.72 129.449 84.4553 130.219 72.3607 127.789Z",
    fill: "white",
    stroke: "#F3F5FF",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsx("mask", {
    id: "path-18-inside-4_242_4608",
    fill: "white",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M48.5233 112.604C51.6631 119.738 59.7346 125.295 72.3232 127.824C84.4374 130.258 98.7267 129.485 112.695 126.223C113.653 125.454 114.566 124.661 115.428 123.846C128.75 111.252 124.98 98.116 107.007 94.5048C89.0342 90.8936 63.6646 98.175 50.3425 110.768C49.6959 111.379 49.0896 111.992 48.5233 112.604ZM113.225 126.733C114.328 125.863 115.375 124.961 116.358 124.032C130.061 111.079 126.183 97.5677 107.696 93.8533C89.2098 90.1389 63.1154 97.6283 49.4127 110.581C48.6522 111.3 47.9458 112.021 47.293 112.742C50.4168 120.118 58.6767 125.872 71.634 128.476C84.108 130.982 98.8492 130.149 113.225 126.733Z"
    })
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5233 112.604C51.6631 119.738 59.7346 125.295 72.3232 127.824C84.4374 130.258 98.7267 129.485 112.695 126.223C113.653 125.454 114.566 124.661 115.428 123.846C128.75 111.252 124.98 98.116 107.007 94.5048C89.0342 90.8936 63.6646 98.175 50.3425 110.768C49.6959 111.379 49.0896 111.992 48.5233 112.604ZM113.225 126.733C114.328 125.863 115.375 124.961 116.358 124.032C130.061 111.079 126.183 97.5677 107.696 93.8533C89.2098 90.1389 63.1154 97.6283 49.4127 110.581C48.6522 111.3 47.9458 112.021 47.293 112.742C50.4168 120.118 58.6767 125.872 71.634 128.476C84.108 130.982 98.8492 130.149 113.225 126.733Z",
    fill: "#E1D9FE"
  }), /*#__PURE__*/_jsx("path", {
    d: "M48.5233 112.604L46.4544 112.32L45.9243 112.893L46.1402 113.383L48.5233 112.604ZM112.695 126.223L112.82 127.534L113.818 127.301L114.493 126.758L112.695 126.223ZM113.225 126.733L113.368 128.04L114.339 127.809L115.005 127.284L113.225 126.733ZM47.293 112.742L45.2097 112.473L44.703 113.032L44.9062 113.512L47.293 112.742ZM73.7766 126.45C61.6781 124.019 53.9239 118.681 50.9064 111.825L46.1402 113.383C49.4023 120.795 57.791 126.57 70.8698 129.198L73.7766 126.45ZM112.571 124.912C99.1466 128.047 85.4195 128.79 73.7766 126.45L70.8698 129.198C83.4553 131.727 98.3068 130.923 112.82 127.534L112.571 124.912ZM113.467 123.452C112.656 124.219 111.797 124.964 110.897 125.687L114.493 126.758C115.509 125.943 116.476 125.103 117.389 124.24L113.467 123.452ZM105.554 95.8787C122.444 99.2723 125.987 111.617 113.467 123.452L117.389 124.24C131.514 110.888 127.516 96.9597 108.46 93.1309L105.554 95.8787ZM52.3034 111.162C64.8227 99.3277 88.6637 92.4851 105.554 95.8787L108.46 93.1309C89.4046 89.3021 62.5065 97.0222 48.3817 110.374L52.3034 111.162ZM50.5922 112.889C51.1246 112.313 51.6948 111.737 52.3034 111.162L48.3817 110.374C47.6969 111.022 47.0546 111.67 46.4544 112.32L50.5922 112.889ZM114.397 123.638C113.471 124.514 112.485 125.363 111.446 126.183L115.005 127.284C116.172 126.362 117.28 125.409 118.319 124.426L114.397 123.638ZM106.243 95.2272C123.646 98.724 127.297 111.444 114.397 123.638L118.319 124.426C132.824 110.715 128.719 96.4114 109.15 92.4794L106.243 95.2272ZM51.3736 110.975C64.2735 98.7811 88.8394 91.7304 106.243 95.2272L109.15 92.4794C89.5803 88.5474 61.9573 96.4756 47.4519 110.187L51.3736 110.975ZM49.3764 113.011C49.9911 112.332 50.6566 111.653 51.3736 110.975L47.4519 110.187C46.6478 110.948 45.9005 111.71 45.2097 112.473L49.3764 113.011ZM73.0874 127.102C60.6255 124.598 52.6843 119.066 49.6799 111.971L44.9062 113.512C48.1493 121.17 56.7278 127.146 70.1806 129.849L73.0874 127.102ZM113.083 125.427C99.2567 128.712 85.0848 129.512 73.0874 127.102L70.1806 129.849C83.1312 132.452 98.4418 131.587 113.368 128.04L113.083 125.427Z",
    fill: "#F3F5FF",
    mask: "url(#path-18-inside-4_242_4608)"
  }), /*#__PURE__*/_jsx("circle", {
    r: "17.9676",
    transform: "matrix(0.980406 0.196988 -0.726705 0.686949 118.378 83.7552)",
    fill: "white",
    stroke: "#F3F5FF",
    strokeWidth: "2"
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("filter", {
      id: "filter0_dd_242_4608",
      x: "0.351562",
      y: "19.5849",
      width: "203.896",
      height: "163.473",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_242_4608"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_242_4608",
        result: "effect2_dropShadow_242_4608"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_242_4608",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter1_f_242_4608",
      x: "19.6533",
      y: "48.981",
      width: "162.877",
      height: "103.749",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "0.5",
        result: "effect1_foregroundBlur_242_4608"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_242_4608",
      x1: "185.486",
      y1: "68.549",
      x2: "12.141",
      y2: "26.2741",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#8B98DE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.200284",
        stopColor: "#C1CBFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.303741",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.310958",
        stopColor: "#DDE2FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.333069",
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.491969",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.857402",
        stopColor: "#94A0E3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#DAE0FF"
      })]
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "paint1_linear_242_4608",
      x1: "184.639",
      y1: "64.1857",
      x2: "-145.064",
      y2: "490.955",
      gradientUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      })
    }), /*#__PURE__*/_jsx("linearGradient", {
      id: "paint2_linear_242_4608",
      x1: "184.059",
      y1: "63.6054",
      x2: "-145.644",
      y2: "490.375",
      gradientUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("stop", {
        stopColor: "white"
      })
    })]
  })]
});
export const InviteMembersIcon = () => /*#__PURE__*/_jsxs("svg", {
  width: "195",
  height: "180",
  viewBox: "0 0 195 180",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    d: "M168.66 99.6332L167.766 99.7328L168.66 99.6332ZM152.536 77.8052C152.147 77.695 151.58 77.8393 151.269 78.1274C150.957 78.4155 151.02 78.7384 151.409 78.8485L152.536 77.8052ZM152.391 79.1404C152.771 79.2586 153.34 79.1236 153.662 78.8387C153.984 78.5539 153.938 78.2271 153.558 78.1088L152.391 79.1404ZM157.392 79.5358C157.051 79.3859 156.48 79.4829 156.117 79.7524C155.754 80.022 155.735 80.362 156.076 80.512L157.392 79.5358ZM157.762 81.3167C158.082 81.4817 158.65 81.4043 159.033 81.1437C159.415 80.8832 159.465 80.5381 159.146 80.3731L157.762 81.3167ZM162.302 82.2819C162.029 82.0883 161.469 82.1259 161.053 82.3659C160.637 82.606 160.522 82.9576 160.796 83.1513L162.302 82.2819ZM162.133 84.1751C162.383 84.3821 162.935 84.3646 163.366 84.136C163.796 83.9074 163.943 83.5542 163.694 83.3471L162.133 84.1751ZM166.081 85.6815C165.882 85.4498 165.35 85.427 164.894 85.6307C164.437 85.8343 164.229 86.1871 164.428 86.4188L166.081 85.6815ZM165.377 87.6315C165.55 87.8744 166.069 87.9172 166.536 87.7271C167.003 87.537 167.242 87.186 167.069 86.9431L165.377 87.6315ZM168.618 89.6346C168.5 89.3716 168.012 89.2892 167.528 89.4504C167.044 89.6117 166.748 89.9555 166.866 90.2185L168.618 89.6346ZM167.401 91.5845C167.492 91.8562 167.962 91.9581 168.452 91.8122C168.941 91.6662 169.265 91.3276 169.174 91.0559L167.401 91.5845ZM169.84 94.0265C169.805 93.7399 169.375 93.6001 168.878 93.7142C168.381 93.8283 168.006 94.153 168.04 94.4396L169.84 94.0265ZM168.143 95.9193C168.149 96.2119 168.558 96.37 169.056 96.2725C169.554 96.1749 169.952 95.8586 169.946 95.566L168.143 95.9193ZM169.708 98.7291C169.758 98.4272 169.398 98.2342 168.903 98.2978C168.407 98.3614 167.964 98.6576 167.914 98.9594L169.708 98.7291ZM167.682 100.123C167.618 100.427 167.965 100.628 168.459 100.573C168.953 100.518 169.406 100.228 169.471 99.9242L167.682 100.123ZM169.137 101.487C169.202 101.183 168.854 100.982 168.36 101.037C167.866 101.092 167.413 101.382 167.349 101.686L169.137 101.487ZM151.409 78.8485C151.741 78.9425 152.068 79.0398 152.391 79.1404L153.558 78.1088C153.222 78.0042 152.881 77.9029 152.536 77.8052L151.409 78.8485ZM156.076 80.512C156.658 80.7679 157.22 81.0363 157.762 81.3167L159.146 80.3731C158.582 80.0813 157.997 79.8021 157.392 79.5358L156.076 80.512ZM160.796 83.1513C161.263 83.4815 161.709 83.8229 162.133 84.1751L163.694 83.3471C163.252 82.9807 162.788 82.6255 162.302 82.2819L160.796 83.1513ZM164.428 86.4188C164.767 86.8134 165.083 87.2178 165.377 87.6315L167.069 86.9431C166.763 86.5127 166.433 86.092 166.081 85.6815L164.428 86.4188ZM166.866 90.2185C167.068 90.6658 167.246 91.1213 167.401 91.5845L169.174 91.0559C169.013 90.5739 168.828 90.1 168.618 89.6346L166.866 90.2185ZM168.04 94.4396C168.099 94.9264 168.133 95.4198 168.143 95.9193L169.946 95.566C169.936 95.0463 169.9 94.533 169.84 94.0265L168.04 94.4396ZM167.914 98.9594C167.87 99.216 167.821 99.4738 167.766 99.7328L169.554 99.5336C169.612 99.2642 169.663 98.996 169.708 98.7291L167.914 98.9594ZM167.766 99.7328L167.682 100.123L169.471 99.9242L169.554 99.5336L167.766 99.7328ZM167.349 101.686L167.265 102.077L169.053 101.877L169.137 101.487L167.349 101.686Z",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("path", {
    d: "M85.0414 75.0236C85.5389 74.9163 85.9239 74.5949 85.9013 74.3057C85.8786 74.0165 85.457 73.8691 84.9595 73.9764L85.0414 75.0236ZM55.8096 95.5958L54.9174 95.6874L55.8096 95.5958ZM55.2042 101.833C55.2762 101.529 54.9351 101.323 54.4423 101.374C53.9495 101.424 53.4917 101.712 53.4197 102.016L55.2042 101.833ZM53.9643 99.7149C53.8923 100.019 54.2334 100.225 54.7262 100.174C55.219 100.124 55.6768 99.8359 55.7488 99.5316L53.9643 99.7149ZM56.0211 98.3809C56.0931 98.0767 55.752 97.871 55.2592 97.9216C54.7665 97.9722 54.3086 98.2599 54.2366 98.5642L56.0211 98.3809ZM54.7812 96.2628C54.7092 96.567 55.0503 96.7727 55.5431 96.7221C56.0359 96.6715 56.4937 96.3838 56.5657 96.0795L54.7812 96.2628ZM56.89 94.7983C56.9807 94.4923 56.6572 94.2759 56.1675 94.3149C55.6779 94.3539 55.2074 94.6336 55.1167 94.9395L56.89 94.7983ZM56.3681 91.9235C56.2038 92.2318 56.4516 92.4884 56.9217 92.4965C57.3918 92.5047 57.9062 92.2614 58.0705 91.953L56.3681 91.9235ZM58.9128 90.5311C59.1129 90.2243 58.9053 89.9498 58.4493 89.918C57.9932 89.8861 57.4613 90.109 57.2613 90.4158L58.9128 90.5311ZM59.5578 87.4446C59.2902 87.7429 59.4137 88.0483 59.8337 88.1269C60.2537 88.2054 60.8111 88.0272 61.0787 87.729L59.5578 87.4446ZM62.3889 86.3655C62.6879 86.0741 62.6074 85.7559 62.2092 85.6548C61.8109 85.5536 61.2457 85.7078 60.9467 85.9992L62.3889 86.3655ZM64.1634 83.2308C63.8072 83.5033 63.8005 83.8413 64.1486 83.9857C64.4966 84.1301 65.0675 84.0262 65.4237 83.7536L64.1634 83.2308ZM67.1303 82.5203C67.512 82.2596 67.5622 81.9146 67.2424 81.7499C66.9226 81.5851 66.3538 81.6629 65.9721 81.9236L67.1303 82.5203ZM69.9374 79.5017C69.5114 79.7343 69.3751 80.0871 69.633 80.2897C69.8909 80.4923 70.4453 80.468 70.8713 80.2354L69.9374 79.5017ZM72.8843 79.1973C73.3288 78.9809 73.5072 78.6273 73.2827 78.4075C73.0582 78.1876 72.5159 78.1849 72.0713 78.4012L72.8843 79.1973ZM76.5803 76.4542C76.1066 76.6343 75.8471 76.9833 76.0008 77.2337C76.1545 77.4841 76.663 77.5411 77.1368 77.361L76.5803 76.4542ZM79.3508 76.5741C79.8349 76.4138 80.1327 76.0702 80.0159 75.8067C79.8992 75.5432 79.412 75.4595 78.9279 75.6198L79.3508 76.5741ZM83.7416 74.2528C83.2453 74.371 82.8766 74.6977 82.9181 74.9826C82.9596 75.2675 83.3956 75.4027 83.8918 75.2845L83.7416 74.2528ZM55.068 102.408L55.2042 101.833L53.4197 102.016L53.2835 102.592L55.068 102.408ZM55.7488 99.5316L56.0211 98.3809L54.2366 98.5642L53.9643 99.7149L55.7488 99.5316ZM56.5657 96.0795L56.7019 95.5042L54.9174 95.6874L54.7812 96.2628L56.5657 96.0795ZM56.7019 95.5042C56.7576 95.2687 56.8204 95.0334 56.89 94.7983L55.1167 94.9395C55.0429 95.1886 54.9764 95.438 54.9174 95.6874L56.7019 95.5042ZM58.0705 91.953C58.3248 91.476 58.606 91.0017 58.9128 90.5311L57.2613 90.4158C56.9359 90.9147 56.6378 91.4176 56.3681 91.9235L58.0705 91.953ZM61.0787 87.729C61.4918 87.2685 61.929 86.8137 62.3889 86.3655L60.9467 85.9992C60.4592 86.4743 59.9957 86.9564 59.5578 87.4446L61.0787 87.729ZM65.4237 83.7536C65.9727 83.3336 66.542 82.9222 67.1303 82.5203L65.9721 81.9236C65.3486 82.3495 64.7452 82.7856 64.1634 83.2308L65.4237 83.7536ZM70.8713 80.2354C71.5266 79.8776 72.198 79.5313 72.8843 79.1973L72.0713 78.4012C71.3438 78.7554 70.632 79.1225 69.9374 79.5017L70.8713 80.2354ZM77.1368 77.361C77.8633 77.0847 78.6017 76.8221 79.3508 76.5741L78.9279 75.6198C78.1337 75.8828 77.3507 76.1613 76.5803 76.4542L77.1368 77.361ZM83.8918 75.2845C84.2731 75.1936 84.6564 75.1067 85.0414 75.0236L84.9595 73.9764C84.5516 74.0644 84.1456 74.1565 83.7416 74.2528L83.8918 75.2845Z",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("path", {
    d: "M81.6574 146.988L82.1982 146.46L81.6574 146.988ZM115.222 142.42C115.657 142.194 115.812 141.841 115.57 141.63C115.327 141.42 114.777 141.432 114.342 141.657L115.222 142.42ZM113.34 142.162C112.897 142.379 112.72 142.733 112.947 142.952C113.173 143.171 113.716 143.173 114.159 142.955L113.34 142.162ZM109.714 144.887C110.187 144.706 110.444 144.357 110.289 144.107C110.133 143.857 109.624 143.802 109.151 143.983L109.714 144.887ZM106.968 144.764C106.484 144.925 106.188 145.269 106.307 145.532C106.425 145.795 106.914 145.877 107.397 145.716L106.968 144.764ZM102.646 147.076C103.142 146.957 103.51 146.63 103.466 146.345C103.423 146.061 102.986 145.927 102.49 146.046L102.646 147.076ZM100.222 146.539C99.7238 146.636 99.3241 146.952 99.3291 147.245C99.334 147.537 99.7417 147.696 100.24 147.599L100.222 146.539ZM95.4353 148.317C95.9282 148.266 96.3855 147.978 96.4567 147.674C96.5279 147.37 96.1861 147.164 95.6932 147.215L95.4353 148.317ZM93.4598 147.395C92.9738 147.423 92.4916 147.694 92.3828 148.001C92.274 148.308 92.5797 148.535 93.0657 148.507L93.4598 147.395ZM88.4614 148.545C88.9249 148.565 89.4483 148.332 89.6303 148.024C89.8123 147.716 89.5841 147.45 89.1205 147.431L88.4614 148.545ZM87.0403 147.286C86.5922 147.243 86.0528 147.455 85.8357 147.761C85.6185 148.066 85.8058 148.349 86.254 148.392L87.0403 147.286ZM82.0944 147.746C82.504 147.836 83.0657 147.67 83.3489 147.374C83.6321 147.079 83.5297 146.767 83.12 146.678L82.0944 147.746ZM81.0837 146.178C80.6852 146.077 80.12 146.232 79.8213 146.523C79.5226 146.814 79.6035 147.133 80.002 147.233L81.0837 146.178ZM75.5438 146.104C75.9423 146.205 76.5075 146.051 76.8061 145.759C77.1048 145.468 77.0239 145.15 76.6254 145.049L75.5438 146.104ZM74.3963 144.484C73.9978 144.383 73.4326 144.538 73.1339 144.829C72.8353 145.121 72.9162 145.439 73.3147 145.54L74.3963 144.484ZM68.8564 144.411C69.2549 144.512 69.8201 144.357 70.1188 144.066C70.4175 143.774 70.3365 143.456 69.938 143.355L68.8564 144.411ZM114.342 141.657C114.011 141.829 113.677 141.998 113.34 142.162L114.159 142.955C114.516 142.781 114.871 142.602 115.222 142.42L114.342 141.657ZM109.151 143.983C108.429 144.259 107.701 144.52 106.968 144.764L107.397 145.716C108.175 145.457 108.948 145.18 109.714 144.887L109.151 143.983ZM102.49 146.046C101.735 146.227 100.978 146.392 100.222 146.539L100.24 147.599C101.042 147.443 101.845 147.268 102.646 147.076L102.49 146.046ZM95.6932 147.215C94.9445 147.293 94.1994 147.353 93.4598 147.395L93.0657 148.507C93.8505 148.463 94.6409 148.399 95.4353 148.317L95.6932 147.215ZM89.1205 147.431C88.4179 147.401 87.724 147.353 87.0403 147.286L86.254 148.392C86.9795 148.463 87.7158 148.513 88.4614 148.545L89.1205 147.431ZM83.12 146.678C82.8095 146.61 82.5021 146.537 82.1982 146.46L81.1166 147.516C81.4389 147.597 81.7649 147.674 82.0944 147.746L83.12 146.678ZM82.1982 146.46L81.0837 146.178L80.002 147.233L81.1166 147.516L82.1982 146.46ZM76.6254 145.049L74.3963 144.484L73.3147 145.54L75.5438 146.104L76.6254 145.049ZM69.938 143.355L68.8235 143.073L67.7419 144.129L68.8564 144.411L69.938 143.355Z",
    fill: "#D4D4E0"
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter0_dd_250_6262)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M144.836 81.4686C135.19 91.1148 116.617 96.353 103.352 93.1684C98.7364 92.0603 93.8277 88.6005 91.8086 86.0807C86.8685 78.6706 90.5101 76.2259 96.7999 69.9361C106.446 60.2899 125.019 55.0518 138.284 58.2364C140.684 58.8126 142.28 58.7433 143.925 59.6212C144.181 59.7583 144.389 59.9269 144.566 60.1089C150.533 66.2369 152.492 73.813 144.836 81.4686Z",
      fill: "url(#paint0_linear_250_6262)"
    })
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter1_dd_250_6262)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M169.379 130.678C159.733 140.324 141.16 145.562 127.895 142.378C123.279 141.27 118.371 137.81 116.352 135.29C111.411 127.88 115.053 125.435 121.343 119.146C130.989 109.499 149.562 104.261 162.827 107.446C165.227 108.022 166.823 107.953 168.468 108.831C168.724 108.968 168.932 109.136 169.109 109.318C175.076 115.446 177.035 123.022 169.379 130.678Z",
      fill: "url(#paint1_linear_250_6262)"
    })
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter2_dd_250_6262)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M75.5169 133.766C65.8707 143.412 47.2976 148.65 34.0327 145.465C29.4171 144.357 24.5084 140.898 22.4892 138.378C17.5492 130.968 21.1908 128.523 27.4805 122.233C37.1268 112.587 55.6998 107.349 68.9647 110.533C71.3646 111.11 72.9603 111.04 74.6053 111.918C74.8621 112.055 75.0698 112.224 75.2471 112.406C81.2137 118.534 83.1726 126.11 75.5169 133.766Z",
      fill: "url(#paint2_linear_250_6262)"
    })
  }), /*#__PURE__*/_jsx("circle", {
    r: "24.7006",
    transform: "matrix(0.97237 0.233445 -0.707107 0.707107 142.863 122.436)",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M142.325 123.152C142.25 123.123 142.141 123.097 142.037 123.082C139.975 122.522 139.552 120.861 141.097 119.316C142.678 117.735 145.715 116.872 147.901 117.397C150.075 117.919 150.556 119.626 148.975 121.207C147.418 122.75 144.491 123.607 142.325 123.152Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M144.511 130.824C140.95 131.734 137.251 131.918 134.128 131.169C131.006 130.419 129.037 128.874 128.322 126.937C129.263 126.145 130.787 125.515 132.701 125.195C137.581 124.395 142.961 125.687 144.638 128.061C145.294 128.998 145.211 129.974 144.511 130.824Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M134.129 131.169C140.761 132.761 150.048 130.142 154.871 125.319C159.694 120.496 158.227 115.295 151.595 113.703C144.963 112.11 135.676 114.73 130.853 119.553C126.03 124.376 127.497 129.576 134.129 131.169Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("circle", {
    r: "24.7006",
    transform: "matrix(0.97237 0.233445 -0.707107 0.707107 48.4838 125.227)",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M47.946 125.943C47.8707 125.914 47.7626 125.888 47.6578 125.874C45.5966 125.314 45.1728 123.653 46.7186 122.107C48.2993 120.526 51.3363 119.663 53.522 120.188C55.6956 120.71 56.1772 122.418 54.5965 123.998C53.0388 125.541 50.112 126.398 47.946 125.943Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M50.1317 133.615C46.5707 134.526 42.8719 134.71 39.7496 133.96C36.6272 133.211 34.6576 131.666 33.9435 129.729C34.8845 128.937 36.4085 128.306 38.3222 127.986C43.2021 127.187 48.5822 128.478 50.2593 130.852C50.9154 131.789 50.8326 132.766 50.1317 133.615Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M39.7501 133.96C46.3826 135.552 55.6691 132.933 60.4922 128.11C65.3153 123.287 63.8485 118.086 57.2161 116.494C50.5837 114.902 41.2971 117.521 36.474 122.344C31.6509 127.167 33.1177 132.368 39.7501 133.96Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("circle", {
    r: "24.7006",
    transform: "matrix(0.97237 0.233445 -0.707107 0.707107 118.348 73.2322)",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M117.81 73.948C117.735 73.9191 117.627 73.8931 117.522 73.8788C115.461 73.319 115.037 71.6578 116.583 70.1121C118.164 68.5314 121.201 67.6686 123.386 68.1933C125.56 68.7151 126.041 70.4227 124.461 72.0034C122.903 73.5462 119.976 74.403 117.81 73.948Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M119.996 81.6204C116.435 82.5307 112.736 82.7148 109.614 81.9652C106.491 81.2156 104.522 79.6706 103.808 77.734C104.749 76.9419 106.273 76.3114 108.186 75.9912C113.066 75.1917 118.446 76.4834 120.124 78.857C120.78 79.7943 120.697 80.7707 119.996 81.6204Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M109.614 81.9652C116.247 83.5575 125.533 80.9385 130.356 76.1154C135.18 71.2923 133.713 66.0916 127.08 64.4992C120.448 62.9069 111.161 65.526 106.338 70.3491C101.515 75.1722 102.982 80.3729 109.614 81.9652Z",
    stroke: "#6942F8",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("filter", {
      id: "filter0_dd_250_6262",
      x: "69.5078",
      y: "27.3042",
      width: "100.336",
      height: "94.7964",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_6262"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_250_6262",
        result: "effect2_dropShadow_250_6262"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_250_6262",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter1_dd_250_6262",
      x: "94.0508",
      y: "76.5137",
      width: "100.336",
      height: "94.7964",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_6262"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_250_6262",
        result: "effect2_dropShadow_250_6262"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_250_6262",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter2_dd_250_6262",
      x: "0.188477",
      y: "79.6012",
      width: "100.336",
      height: "94.7964",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_6262"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_250_6262",
        result: "effect2_dropShadow_250_6262"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_250_6262",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_250_6262",
      x1: "163.588",
      y1: "63.0934",
      x2: "137.245",
      y2: "30.5415",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#8B98DE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.427083",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.770833",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.857402",
        stopColor: "#94A0E3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.9999",
        stopColor: "#C1CBFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#DAE0FF"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint1_linear_250_6262",
      x1: "188.131",
      y1: "112.303",
      x2: "161.788",
      y2: "79.7509",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#8B98DE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.427083",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.770833",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.857402",
        stopColor: "#94A0E3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.9999",
        stopColor: "#C1CBFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#DAE0FF"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint2_linear_250_6262",
      x1: "94.2691",
      y1: "115.39",
      x2: "67.9262",
      y2: "82.8385",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#8B98DE"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.427083",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.770833",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.857402",
        stopColor: "#94A0E3"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.9999",
        stopColor: "#C1CBFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#DAE0FF"
      })]
    })]
  })]
});
export const GrowClientBaseIcon = () => /*#__PURE__*/_jsxs("svg", {
  width: "182",
  height: "181",
  viewBox: "0 0 182 181",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("g", {
    filter: "url(#filter0_dd_250_5569)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M135.571 52.0388C136.709 50.7736 138.33 50.051 140.032 50.051H157.137C159.346 50.051 161.137 51.8419 161.137 54.051V152.936H136.908L134.788 54.1791L135.102 52.8741V52.5604L135.571 52.0388Z",
      fill: "url(#paint0_linear_250_5569)"
    })
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter1_dd_250_5569)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M97.927 79.0505C99.0658 77.7637 100.702 77.027 102.42 77.027H119.496C121.705 77.027 123.496 78.8178 123.496 81.027V152.936H99.2673L97.4609 80.1637L97.7746 79.2227L97.927 79.0505Z",
      fill: "url(#paint1_linear_250_5569)"
    })
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter2_dd_250_5569)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M60.2864 98.4983C61.4252 97.2115 63.0611 96.4748 64.7794 96.4748H81.8552C84.0644 96.4748 85.8552 98.2657 85.8552 100.475V152.936H61.6266L59.8203 99.6115L60.134 98.6705L60.2864 98.4983Z",
      fill: "url(#paint2_linear_250_5569)"
    })
  }), /*#__PURE__*/_jsx("g", {
    filter: "url(#filter3_dd_250_5569)",
    children: /*#__PURE__*/_jsx("path", {
      d: "M22.6448 111.673C23.7836 110.386 25.4195 109.649 27.1378 109.649H44.2136C46.4228 109.649 48.2136 111.44 48.2136 113.649V152.936H23.985L22.1787 112.786L22.4924 111.845L22.6448 111.673Z",
      fill: "url(#paint3_linear_250_5569)"
    })
  }), /*#__PURE__*/_jsx("path", {
    d: "M134.788 55.3058C134.788 53.0966 136.579 51.3058 138.788 51.3058H155.882C158.091 51.3058 159.882 53.0966 159.882 55.3058V152.936H134.788V55.3058Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M97.1475 82.2818C97.1475 80.0727 98.9383 78.2818 101.147 78.2818H118.241C120.45 78.2818 122.241 80.0727 122.241 82.2818V152.936H97.1475V82.2818Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M59.5059 101.729C59.5059 99.5204 61.2967 97.7295 63.5059 97.7295H80.5998C82.8089 97.7295 84.5998 99.5204 84.5998 101.729V152.936H59.5059V101.729Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M21.8662 114.904C21.8662 112.695 23.6571 110.904 25.8662 110.904H42.9601C45.1692 110.904 46.9601 112.695 46.9601 114.904V152.936H21.8662V114.904Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9.00488 116.455C9.00488 116.455 59.82 123.043 106.244 96.0666C152.667 69.0906 160.068 40.6078 160.068 40.6078",
    stroke: "#6942F8",
    strokeWidth: "4",
    strokeLinecap: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M154.535 42.4021L160.465 39.6295L163.096 45.2554",
    stroke: "#6942F8",
    strokeWidth: "4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9 153.406L170.38 153.406",
    stroke: "#282863",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("filter", {
      id: "filter0_dd_250_5569",
      x: "114.788",
      y: "20.051",
      width: "66.3486",
      height: "160.885",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_5569"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_250_5569",
        result: "effect2_dropShadow_250_5569"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_250_5569",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter1_dd_250_5569",
      x: "77.4609",
      y: "47.027",
      width: "66.0352",
      height: "133.909",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_5569"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_250_5569",
        result: "effect2_dropShadow_250_5569"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_250_5569",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter2_dd_250_5569",
      x: "39.8203",
      y: "66.4748",
      width: "66.0352",
      height: "114.461",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_5569"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_250_5569",
        result: "effect2_dropShadow_250_5569"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_250_5569",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("filter", {
      id: "filter3_dd_250_5569",
      x: "2.17871",
      y: "79.649",
      width: "66.0352",
      height: "101.287",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "-10"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_250_5569"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /*#__PURE__*/_jsx("feOffset", {
        dy: "8"
      }), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "10"
      }), /*#__PURE__*/_jsx("feComposite", {
        in2: "hardAlpha",
        operator: "out"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_250_5569",
        result: "effect2_dropShadow_250_5569"
      }), /*#__PURE__*/_jsx("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_250_5569",
        result: "shape"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint0_linear_250_5569",
      x1: "128.362",
      y1: "61.097",
      x2: "141.08",
      y2: "84.9666",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#DCE0F4"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.247812",
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.303741",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.529511",
        stopColor: "#DDE2FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.673845",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.740917",
        stopColor: "#C1CAFB"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#C2C8EB"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint1_linear_250_5569",
      x1: "90.7208",
      y1: "85.1767",
      x2: "98.4197",
      y2: "104.761",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#DCE0F4"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.247812",
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.303741",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.529511",
        stopColor: "#DDE2FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.673845",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.740917",
        stopColor: "#C1CAFB"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#C2C8EB"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint2_linear_250_5569",
      x1: "53.0802",
      y1: "104.625",
      x2: "60.7791",
      y2: "124.209",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#DCE0F4"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.247812",
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.303741",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.529511",
        stopColor: "#DDE2FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.673845",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.740917",
        stopColor: "#C1CAFB"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#C2C8EB"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "paint3_linear_250_5569",
      x1: "15.4385",
      y1: "117.799",
      x2: "23.1374",
      y2: "137.383",
      gradientUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("stop", {
        stopColor: "#DCE0F4"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.247812",
        stopColor: "white"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.303741",
        stopColor: "#E9ECFF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.529511",
        stopColor: "#DDE2FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.673845",
        stopColor: "#CED6FF"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "0.740917",
        stopColor: "#C1CAFB"
      }), /*#__PURE__*/_jsx("stop", {
        offset: "1",
        stopColor: "#C2C8EB"
      })]
    })]
  })]
});